import React, { useState, useEffect, useCallback } from "react";
import axiosInstance from "../utils/axiosInstance";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

const fmtDate = (d) => {
  if (!d) return "—";
  try { return new Date(d).toLocaleDateString("rw-RW", { year:"numeric", month:"short", day:"numeric" }); }
  catch { return d; }
};

const RaporoZoherejweAkagari = () => {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch]   = useState("");
  const [toast, setToast]     = useState(null);
  const navigate = useNavigate();

  // Mudugudu navigation — click a Mudugudu to see only its reports.
  const [imidugudu, setImidugudu] = useState([]);
  const [mudugudFilter, setMudugudFilter] = useState(null); // null = all

  useEffect(() => {
    axiosInstance.get("/raporo/mudugudu-list")
      .then((res) => setImidugudu(Array.isArray(res.data) ? res.data : []))
      .catch(() => setImidugudu([]));
  }, []);

  const notify = (msg, type = "success") => {
    setToast({ msg, type });
    setTimeout(() => setToast(null), 3500);
  };

  const fetchReports = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axiosInstance.get("/raporo_akagari", {
        params: mudugudFilter ? { mudugudu_id: mudugudFilter } : {},
      });
      setReports(Array.isArray(res.data) ? res.data : []);
    } catch {
      notify("Ntibyashobotse kubona raporo. Gerageza nanone.", "error");
    } finally { setLoading(false); }
  }, [mudugudFilter]);

  useEffect(() => { fetchReports(); }, [fetchReports]);

  const filtered = reports.filter(r =>
    (r.umutwe_wa_raporo || "").toLowerCase().includes(search.toLowerCase()) ||
    (r.umudugudu_name || "").toLowerCase().includes(search.toLowerCase()) ||
    (r.yakozwe_na || "").toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div style={{ fontFamily:"system-ui,sans-serif" }}>
      {toast && (
        <div style={{ position:"fixed", top:20, right:20, zIndex:9999, padding:"12px 20px", borderRadius:12, fontWeight:600, fontSize:14,
          background: toast.type === "success" ? "#ecfdf5" : "#fef2f2",
          color: toast.type === "success" ? "#065f46" : "#991b1b",
          border: `1px solid ${toast.type === "success" ? "#a7f3d0" : "#fecaca"}`,
          boxShadow:"0 4px 20px rgba(0,0,0,0.1)" }}>
          {toast.msg}
        </div>
      )}

      {/* Header */}
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:20, flexWrap:"wrap", gap:12 }}>
        <div>
          <h2 style={{ fontSize:22, fontWeight:700, color:"#1a2332", margin:0 }}>
            <i className="bi bi-send-fill me-2" style={{ color:"#003580" }}></i>
            Raporo Zoherejwe na Umudugudu
          </h2>
          <p style={{ color:"#6b7280", fontSize:13, marginTop:4 }}>{reports.length} raporo zoherejwe</p>
        </div>
        <button onClick={fetchReports} disabled={loading}
          style={{ padding:"9px 18px", background:"#003580", color:"#fff", border:"none", borderRadius:10, fontWeight:700, fontSize:13, cursor:"pointer", display:"flex", alignItems:"center", gap:6, minHeight:40 }}>
          <i className={`bi ${loading ? "bi-arrow-repeat" : "bi-arrow-clockwise"}`} style={{ animation: loading ? "spin 1s linear infinite" : "none" }} />
          Vugurura
        </button>
      </div>

      {/* Mudugudu navigation — filter reports by which Mudugudu sent them */}
      {imidugudu.length > 0 && (
        <div style={{ display:"flex", gap:8, flexWrap:"wrap", alignItems:"center", marginBottom:14 }}>
          <button onClick={() => setMudugudFilter(null)}
            style={{ padding:"0.4rem 0.9rem", borderRadius:20, fontSize:"0.8rem", fontWeight:700, cursor:"pointer",
              border: `1px solid ${!mudugudFilter ? "#003580" : "#e2e8f0"}`,
              background: !mudugudFilter ? "#003580" : "#f8fafc",
              color: !mudugudFilter ? "#fff" : "#475569" }}>
            Imidugudu Yose
          </button>
          {imidugudu.map((m) => (
            <button key={m.mudugudu_id} onClick={() => setMudugudFilter(m.mudugudu_id)}
              style={{ padding:"0.4rem 0.9rem", borderRadius:20, fontSize:"0.8rem", fontWeight:700, cursor:"pointer",
                border: `1px solid ${mudugudFilter === m.mudugudu_id ? "#003580" : "#e2e8f0"}`,
                background: mudugudFilter === m.mudugudu_id ? "#003580" : "#f8fafc",
                color: mudugudFilter === m.mudugudu_id ? "#fff" : "#475569" }}>
              {m.mudugudu_name}
            </button>
          ))}
        </div>
      )}

      {/* Search */}
      <div style={{ display:"flex", alignItems:"center", gap:8, background:"#f8fafc", border:"1px solid #e2e8f0", borderRadius:10, padding:"0 12px", marginBottom:16 }}>
        <i className="bi bi-search" style={{ color:"#94a3b8" }}></i>
        <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Shakisha raporo..."
          style={{ border:"none", background:"transparent", outline:"none", padding:"0.6rem 0.25rem", fontSize:"0.88rem", color:"#1e293b", width:"100%" }} />
        {search && <button onClick={() => setSearch("")} style={{ background:"none", border:"none", cursor:"pointer", color:"#94a3b8", padding:0 }}><i className="bi bi-x-circle-fill"></i></button>}
      </div>

      {loading && <div style={{ textAlign:"center", padding:"4rem 0" }}><div className="spinner-border" style={{ width:"3rem", height:"3rem", color:"#003580" }} /><p style={{ marginTop:"1rem", color:"#64748b" }}>Raporo zirimo gutegurwa...</p></div>}

      {!loading && filtered.length === 0 && (
        <div style={{ textAlign:"center", padding:"5rem 2rem", background:"#fff", borderRadius:14, border:"1px solid #e5e7eb" }}>
          <i className="bi bi-inbox" style={{ fontSize:48, color:"#d1d5db", display:"block", marginBottom:12 }}></i>
          <h5 style={{ color:"#374151", fontWeight:700 }}>{search ? "Nta raporo ibonetse" : "Nta raporo yoherejwe"}</h5>
          <p style={{ color:"#9ca3af", fontSize:14 }}>{search ? "Hindura amagambo yo gushakisha" : "Imidugudu ntiyohereje raporo narimwe"}</p>
        </div>
      )}

      {!loading && filtered.length > 0 && (
        <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
          {filtered.map((r, i) => (
            <motion.div key={r.raporo_id || i}
              initial={{ opacity:0, y:10 }} animate={{ opacity:1, y:0 }} transition={{ delay: i * 0.04 }}
              style={{ background:"#fff", border:"1px solid #e5e7eb", borderLeft:"4px solid #003580", borderRadius:12, padding:"1.25rem 1.5rem", boxShadow:"0 2px 8px rgba(0,0,0,0.05)", cursor:"pointer" }}
              onClick={() => navigate(`/view-report/${r.raporo_id}`)}
              onMouseEnter={e => e.currentTarget.style.boxShadow = "0 6px 20px rgba(0,53,128,0.12)"}
              onMouseLeave={e => e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.05)"}>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", gap:12, flexWrap:"wrap" }}>
                <div style={{ flex:1, minWidth:0 }}>
                  <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:6, flexWrap:"wrap" }}>
                    <div style={{ width:34, height:34, borderRadius:10, background:"#dbeafe", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
                      <i className="bi bi-file-earmark-text-fill" style={{ color:"#003580", fontSize:"0.95rem" }}></i>
                    </div>
                    <h6 style={{ fontWeight:700, margin:0, color:"#1e293b", fontSize:"0.95rem" }}>{r.umutwe_wa_raporo || "Raporo"}</h6>
                    <span style={{ fontSize:"0.72rem", fontWeight:700, padding:"3px 10px", borderRadius:20, background:"#dbeafe", color:"#1d4ed8", border:"1px solid #bfdbfe" }}>
                      {r.statut || "Itegereje Akagari"}
                    </span>
                    <span style={{ fontSize:"0.72rem", fontWeight:700, padding:"3px 10px", borderRadius:20, background:"#dcfce7", color:"#15803d", border:"1px solid #bbf7d0" }}>
                      🟢 Yoherejwe
                    </span>
                  </div>
                  <div style={{ display:"flex", gap:14, flexWrap:"wrap" }}>
                    <span style={{ fontSize:"0.8rem", color:"#64748b", display:"flex", alignItems:"center", gap:4 }}>
                      <i className="bi bi-building" style={{ color:"#003580" }}></i>{r.umudugudu_name || "—"}
                    </span>
                    <span style={{ fontSize:"0.8rem", color:"#64748b", display:"flex", alignItems:"center", gap:4 }}>
                      <i className="bi bi-person-fill" style={{ color:"#7c3aed" }}></i>{r.yakozwe_na || "—"}
                    </span>
                    <span style={{ fontSize:"0.8rem", color:"#64748b", display:"flex", alignItems:"center", gap:4 }}>
                      <i className="bi bi-calendar-fill" style={{ color:"#b45309" }}></i>{fmtDate(r.itariki_ya_raporo)}
                    </span>
                    <span style={{ fontSize:"0.8rem", color:"#15803d", display:"flex", alignItems:"center", gap:4 }}>
                      <i className="bi bi-send-fill"></i>Yoherejwe: {fmtDate(r.forwarded_at)}
                    </span>
                  </div>
                </div>
                <button onClick={e => { e.stopPropagation(); navigate(`/view-report/${r.raporo_id}`); }}
                  style={{ display:"flex", alignItems:"center", gap:5, padding:"0.5rem 0.875rem", background:"linear-gradient(135deg,#003580,#1a56b0)", border:"none", borderRadius:8, color:"#fff", fontWeight:600, fontSize:"0.8rem", cursor:"pointer", flexShrink:0 }}>
                  <i className="bi bi-eye-fill"></i> Soma
                </button>
              </div>
            </motion.div>
          ))}
        </div>
      )}
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
};

export default RaporoZoherejweAkagari;
